export const COMPANY_INFO = {
  name: "Tepih Servis Tip-Top Novi Sad",
  foundedYear: "2012",
  phone: "064 112 4782",
  address: "Janošikova 11a, Novi Sad",
  social: {
    facebook: "https://www.facebook.com/p/TipTop-tepih-servis-Novi-Sad-100054586323229/?locale=sr_RS",
    instagram: "https://www.instagram.com/tepih.servis.tip.top.novi.sad/"
  },
  colors: {
    orange: "#FF6A00",
    blue: "#004AAD",
    lightBlue: "#4FC3F7",
    darkNavy: "#111827"
  },
  mapUrl: "https://www.google.com/maps/search/?api=1&query=Janošikova+11a+Novi+Sad"
};

export const NAV_LINKS = [
  { name: "Početna", href: "#hero" },
  { name: "Usluge", href: "#usluge" },
  { name: "Proces", href: "#proces" },
  { name: "Galerija", href: "#galerija" },
  { name: "Cenovnik", href: "#cenovnik" },
  { name: "Kontakt", href: "#kontakt" },
];

export const SERVICES = [
  {
    id: 1,
    title: "Dubinsko pranje tepiha",
    icon: "Carpet",
    description: "Masina sa cak 10 cetki vrsi pranje vasih tepiha i vraca vase tepihe u stanje kao nove."
  },
  {
    id: 2,
    title: "Dubinsko pranje nameštaja",
    icon: "Sofa",
    description: "Pranje se vrsi profesionalnim masinama uz pomoc vrhunske antibakterijske hemije."
  },
  {
    id: 3,
    title: "Preuzimanje i vraćanje",
    icon: "Truck",
    description: "Preuzimanje i vraćanje tepiha na vašu adresu u Novom Sadu."
  }
];

export const PROCESS_STEPS = [
  { title: "Istresanje prašine", description: "Mašinsko istresanje prasine iz tepiha." },
  { title: "Tretiranje fleka", description: "Poseban tretman za najtvrdokornije fleke pre pranja na masini." },
  { title: "Mašinsko pranje", description: "Pranje automatskom mašinom sa 10 rotirajućih četki." },
  { title: "Ispiranje i susenje", description: "Ispiranje i susenje tepiha u centrifugi." },
  { title: "Sušenje u komori", description: "Sušenje u najsavremenijim komorama bez obzira na vremske uslove." },
  { title: "Kontrola i pakovanje", description: "Finalni pregled, usisavanje, češljanje i pakovanje tepiha. Pakovanje u zastitnu foliju na zahtev klijenta." },
  { title: "Vraćanje 100% suvih tepiha", description: "Vraćamo vam tepihe potpuno suve i spremne za upotrebu odmah po isporuci." }
];

export const BENEFITS = [
  { title: "Savremena oprema", description: "Koristimo najnovije mašine za maksimalnu efikasnost." },
  { title: "Odnos cene i kvaliteta", description: "Premium usluga po pristupacnim cenama." },
  { title: "Termo-komore", description: "Vaši tepisi su suvi i spremni za isporuku u dogovorenom roku." },
  { title: "Profesionalni pristup", description: "Iskusan tim koji brine o vašim tepisima." },
  { title: "Brza usluga", description: "Poštujemo vaše vreme i dogovorene rokove." }
];

export const REVIEWS = [
  { 
    name: "Marijana Vujkov", 
    rating: 5, 
    text: "Одлична сарадња током година. Услуга је брза, професионална и квалитетна. Моји теписи су бели и запрљају се врло лако и брзо. Било је мрља од кафе, црног вина, фломастера, шминке, а моји теписи су увек били савршено опрани. Ово је једна од оних услуга за које никада не бринем да ли ћу бити задовољан и зато се увек радујем сарадњи!" 
  },
  { 
    name: "Zorana Dobric", 
    rating: 5, 
    text: "Толико професионално да сам одушевљен. Теписи су савршено чисти и мирисни и човек увек дође у тачно време које каже. И теписоне враћа на адресу када каже да ће их донети. Уз све ово, веома су приступачне. Честитамо!" 
  },
  { 
    name: "Biljana Bakic", 
    rating: 5, 
    text: "Брзо, уредно, професионално и теписи су опрани до стандарда за медаљу... изгледају боље него када сам их купио... и дишу и миришу... Топло се препоручује!" 
  },
  { 
    name: "Borislav Jurisic", 
    rating: 5, 
    text: "Све препоруке за ову услугу! Убедљиво најбољи у граду и по цени и по квалитету услуге!" 
  },
  { 
    name: "Dragan Okuka", 
    rating: 5, 
    text: "Вратили су тепих у првобитно стање. Не само да је чист и мирисан, него су га и вратили истрошеног као да га гледам у изложбеном салону. И све по нормалној цени за два-три дана. Квалитет изнад свега." 
  }
];

export const PRICING = {
  carpets: [
    { name: "Cena dubinskog pranja tepiha", price: "350din/m2" }
  ],
  furniture: [
    { name: "Fotelja", price: "1000 din" },
    { name: "Dvosed", price: "2000 din" },
    { name: "Trosed", price: "3000 din" },
    { name: "Ugaona Garnitura", price: "3500 do 5500 din" }
  ]
};
